module.exports = __webpack_public_path__ + "assets/img/gift.39b631f.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/icons/gift.png
// module id = B1dP
// module chunks = 50